var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"container--max",attrs:{"align":"left","justify":"left"}},[_c('v-col',{},[_c('h1',{staticClass:"align--center margin--top"},[_vm._v(" My Stack ")]),_c('div',{staticClass:"align--center margin--top container_columns--responsive"},[_c('div',[_c('SkillRating',{attrs:{"title":"Front End","skills":[
            { name: 'HTML', rating: 4 },
            { name: 'CSS', rating: 4 },
            { name: 'JavaScript', rating: 4 },
            { name: 'VueJS', rating: 4 },
            { name: 'TypeScript', rating: 3 },
            { name: 'WebPack', rating: 2 }
          ]}}),_c('SkillRating',{attrs:{"title":"Back End","skills":[
            { name: 'Java', rating: 4 },
            { name: 'Spring Boot', rating: 3 },
            { name: 'Python', rating: 2 }
          ]}})],1),_c('div',[_c('SkillRating',{attrs:{"title":"Testing","skills":[
            { name: 'Jest', rating: 4 },
            { name: 'Postman', rating: 3 },
            { name: 'Cypress', rating: 1 }
          ]}}),_c('SkillRating',{attrs:{"title":"CICD","skills":[
            { name: 'Git', rating: 4 },
            { name: 'Docker', rating: 1 },
            { name: 'Jenkins', rating: 1 }
          ]}}),_c('SkillRating',{attrs:{"title":"Other","skills":[
            { name: 'MySql', rating: 3 },
            { name: 'Linux', rating: 3 },
            { name: 'Azure/AWS', rating: 1 }
          ]}})],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }